function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

import getReactDisplayName from 'react-display-name';
import PropTypes from 'prop-types';
import { combineRules } from 'fela';
import createComponent from './createComponent';
import { variables as theme } from '@cloudflare/style-const'; // eslint-disable-line behance/no-deprecated

import { objectKeys } from './types';
var sizePropType = PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.number]);
var scalePropType = PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]);
var longhandSpacingProps = ['margin', 'marginLeft', 'marginRight', 'marginTop', 'marginBottom', 'padding', 'paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom'];
var shorthandSpacingProps = {
  m: ['margin'],
  ml: ['marginLeft'],
  mr: ['marginRight'],
  mt: ['marginTop'],
  mb: ['marginBottom'],
  mx: ['marginLeft', 'marginRight'],
  my: ['marginTop', 'marginBottom'],
  p: ['padding'],
  pl: ['paddingLeft'],
  pr: ['paddingRight'],
  pt: ['paddingTop'],
  pb: ['paddingBottom'],
  px: ['paddingLeft', 'paddingRight'],
  py: ['paddingTop', 'paddingBottom']
};
var spacingProps = longhandSpacingProps.concat(_toConsumableArray(objectKeys(shorthandSpacingProps)));
var sizeProps = ['width', 'height', 'minWidth', 'minHeight', 'maxWidth', 'maxHeight'];
var colorProps = ['color', 'backgroundColor', 'borderColor', 'borderLeftColor', 'borderRightColor', 'borderTopColor', 'borderBottomColor'];
var borderStyleProps = ['borderStyle', 'borderTopStyle', 'borderBottomStyle', 'borderLeftStyle', 'borderRightStyle'];
var borderWidthProps = ['borderWidth', 'borderTopWidth', 'borderBottomWidth', 'borderLeftWidth', 'borderRightWidth'];
var borderRadiusProps = ['borderRadius', 'borderTopLeftRadius', 'borderTopRightRadius', 'borderBottomLeftRadius', 'borderbottomRightRadius'];
var additionalProps = ['fontSize', 'fontWeight', 'textAlign', 'display', 'width', 'verticalAlign'];

var styleRuleProps = _toConsumableArray(spacingProps).concat(sizeProps, colorProps, borderStyleProps, borderWidthProps, borderRadiusProps, additionalProps);

// gotta broaden from Set<StyleRuleProp> to a ReadonlySet<string> so we can check
var propsSet = new Set(styleRuleProps); // Function to construct the prop types object

var makePropTypes = function makePropTypes() {
  var propTypes = {
    fontSize: scalePropType,
    textAlign: sizePropType,
    display: sizePropType,
    width: sizePropType,
    verticalAlign: sizePropType
  };

  var _arr = _toConsumableArray(spacingProps).concat(borderWidthProps, borderRadiusProps);

  for (var _i = 0; _i < _arr.length; _i++) {
    var prop = _arr[_i];
    propTypes[prop] = scalePropType;
  }

  var _arr2 = colorProps.concat(borderStyleProps);

  for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
    var _prop = _arr2[_i2];
    propTypes[_prop] = PropTypes.string;
  }

  for (var _i3 = 0; _i3 < sizeProps.length; _i3++) {
    var _prop2 = sizeProps[_i3];
    propTypes[_prop2] = sizePropType;
  }

  return propTypes;
};

var styledPropTypes = makePropTypes(); // Fela rule which turns component props into a style object

var propsRule = function propsRule(props) {
  return Object.keys(props).filter(function (prop) {
    return propsSet.has(prop);
  }).reduce(function (o, prop) {
    return o[prop] = props[prop], o;
  }, {});
}; // Static breakpoints


var bp = [null, "tablet", "desktop"]; // Ensure value is an array

var arr = function arr(n) {
  return Array.isArray(n) ? n : [n];
}; // Wrap a value in an object with a property name
// assignValueToProperty("margin")(32) returns {margin: 32}


var assignValueToProperty = function assignValueToProperty(property) {
  return function (val) {
    return _defineProperty({}, property, val);
  };
}; // Transform object array into breakpoint syntax
// [{margin: 32}, {margin: 64}] into [{margin: 32}, {"@media screen and (min-width: )": {margin: 64}}]


var media = function media(style, i) {
  if (style === null || style === undefined) return null;
  var breakpoint = bp[i];
  return breakpoint ? _defineProperty({}, breakpoint, style) : style;
};

// Recursive object merge
var merge = function merge(a, b) {
  return Object.assign({}, a, b, Object.keys(b).reduce(function (obj, key) {
    return Object.assign(obj, _defineProperty({}, key, a[key] !== null && _typeof(a[key]) === 'object' ? merge(a[key], b[key]) : b[key]));
  }, {}));
};

var processRules = function processRules(customRules) {
  var rules = _objectSpread({}, customRules); // Expand shorthand spacing properties


  ['padding', 'margin'].forEach(function (property) {
    if (rules.hasOwnProperty(property)) {
      ['Top', 'Bottom', 'Left', 'Right'].forEach(function (position) {
        var attr = "".concat(property).concat(position); // Don't overwrite pre-existing longhand properties

        if (!rules[attr]) {
          rules[attr] = rules[property];
        }
      });
      delete rules[property];
    }
  }); // Expand custom shorthand spacing properties

  Object.keys(rules).filter(function (property) {
    return Object.keys(shorthandSpacingProps).includes(property);
  }).forEach(function (property) {
    Object.assign(rules, shorthandSpacingProps[property].reduce(function (a, b) {
      a[b] = rules[property];
      return a;
    }, {}));
    delete rules[property];
  }); // Convert spacing scales

  rules = Object.keys(rules).filter(function (property) {
    return spacingProps.includes(property);
  }).map(function (property) {
    var propValues = arr(rules[property]).map(function (val) {
      return theme.space[val] || val;
    }).map(assignValueToProperty(property)).map(media).reduce(merge, {});
    delete rules[property];
    return propValues;
  }).reduce(merge, rules); // Convert colors to theme

  rules = Object.keys(rules).filter(function (property) {
    return colorProps.includes(property);
  }).map(function (property) {
    var propValues = arr(rules[property]).map(function (val) {
      // Handle nested '.' syntax
      if (val && val.includes('.')) {
        // Attempt to access nested values, otherwise return what was passed
        try {
          return val.split('.').reduce(function (acc, part) {
            return acc[part];
          }, theme.colors);
        } catch (e) {
          return val;
        }
      } else if (typeof theme.colors[val] === 'string') {
        return theme.colors[val];
      }

      return val;
    }).map(assignValueToProperty(property)).map(media).reduce(merge, {});
    delete rules[property];
    return propValues;
  }).reduce(merge, rules); // font-size

  if (rules.fontSize) {
    var fontSize = arr(rules.fontSize).map(function (val) {
      return theme.fontSizes[val] || val;
    }).map(assignValueToProperty('fontSize')).map(media).reduce(merge, {});
    delete rules.fontSize;
    rules = merge(rules, fontSize);
  } // display


  if (rules.display) {
    var display = arr(rules.display).map(assignValueToProperty('display')).map(media).reduce(merge, {});
    delete rules.display;
    rules = merge(rules, display);
  } // width


  if (rules.width) {
    var width = arr(rules.width).map(assignValueToProperty('width')).map(media).reduce(merge, {});
    delete rules.width;
    rules = merge(rules, width);
  }

  return rules;
};

var emptyRule = function emptyRule() {
  return {};
};

var makeStyledRule = function makeStyledRule(rule) {
  var _rule;

  var combinedRules = combineRules((_rule = rule) !== null && _rule !== void 0 ? _rule : emptyRule, propsRule);
  return function (props, renderer) {
    return processRules(combinedRules(props, renderer));
  };
};

function createStyledComponent(rule, type, passthroughProps) {
  var styledRule = makeStyledRule(rule);
  var Component = createComponent(styledRule, type, passthroughProps);
  Component.propTypes = styledPropTypes;

  if (typeof type === 'function') {
    Component.displayName = getReactDisplayName(type);
  }

  return Component;
}

export default createStyledComponent;
export { colorProps, spacingProps, sizeProps, borderStyleProps, borderWidthProps, borderRadiusProps };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/style-container/es/createStyledComponent.js
// module id = 1286
// module chunks = 0